import React, {Component} from 'react';
import '../../local_node_modules/react-select/dist/react-select.css';
import Table from "../../components/Table/Table";
import {showAxiosError} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import NavBarKS from "../../components/NavBarKS";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import moment from "moment";
import TextOverFlowTooltip from "../../components/TextOverFlowTooltip";
import ExcelExporter from "../../components/ExcelExporter";
import * as headerContent from "../../constants/exportcontent";
import SquareButton from "../../components/SquareButton";
import CreditMovementModal from "./CreditMovementModal";
import {EntegratorConf, VirtualHost} from "../../constants";
import {EntegratorIdentifiers} from "../../helper/enums";
import {defterUnitName} from "../../helper/permission";


class CreditList extends Component {
	constructor(props) {
		super(props);
		this.state = {
		    content: [],
			total: 0,
			loading: false,
			page: 0,
			size: 10,
			searchQuery: undefined
		};
		this.fetchData = this.fetchData.bind(this);
		this.handleSearch 	= this.handleSearch.bind(this);
	}

	fetchData(accessor, direction, page, size) {
		let self = this;
		let sortStr = !!accessor ? ('&sort=' + accessor + ',' + direction) : '';
		let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
		let params = {
			url: '/credit/getCredits?page=' + page + '&size=' + size + sortStr + searchQuery,
			method: "post"
		};
		self.setState({loading: true, manual: self.manual === true ? false: self.manual});
		self.props.reload(true);
		request(params)
		.then(function (response) {
			self.setState({
				page: page,
				size: size,
				total: response.data.totalElements,
				content: response.data.content,
				loading: false,
				searching: false
			});
			self.props.reload(false);
		}).catch(function (error) {
			self.setState({loading: false,searching: false});
			self.props.reload(false);
			showAxiosError(error);
		});
	}

	handleSearch(searchQuery) {
		this.setState({searchQuery, searching: true}, () => this.fetchData(this.state.accessor, this.state.direction, 0, this.state.size))
	}

	getUnitType(unit){
		if(unit === 1){
			return ("Kontör Adeti");
		}else if(unit===2){
			return (defterUnitName(EntegratorConf.identifier));
		}else if(unit===3){
			return ("e-Arşiv Kasa")
		}else{
			return ("Birim Yok");
		}
	}

	getActionType(actionType){
		if(actionType === 0){
			return ("Sıfır Başlangıç");
		}else if(actionType===1){
			return ("Satın Alma");
		}else if(actionType===2){
			return ("Devir (Giriş)");
		}else if(actionType===3){
			return ("Hediye")
		}else if(actionType===4){
			return ("Devir (Çıkış)")
		}else if(actionType===5){
			return ("Transfer")
		}else if(actionType===6){
			return ("Kredi Havuzuna Katılma")
		}else if(actionType===7){
			return ("Kredi Havuzundan Ayrılma")
		}else if(actionType===8){
			return ("Kredi Silme")
		}else{
			return ("Hareket Yok");
		}
	}

	render() {

		const defaultHeaders = headerContent.creditReportContent;
		const source = VirtualHost.conf.resourcePrefix;

		const columns = [
			{
				Header: "VKN/TCKN",
				accessor:"vknTckn"
			},
			{
				Header: "Müşteri Adı",
				accessor:"customer_customerName",
				Cell: row => (<div><TextOverFlowTooltip text={row.customer ? row.customer.customerName :""} maxLength={23}></TextOverFlowTooltip></div>)
			},
			{
				Header: "Birim Türü",
				accessor:"unit",
				Cell: row => (<div>{this.getUnitType(row.unit)}</div>)
			},
			{
				Header: "İşlem Türü",
				accessor:"actionType",
				Cell: row => (<div>{this.getActionType(row.actionType)}</div>)
			},
			{
				Header: "İşlem Tarihi",
				accessor:"purchaseDate",
				sortable:false,
				Cell: row => (<div>{moment(row.purchaseDate).isValid() ? moment(row.purchaseDate).format("DD-MM-YYYY HH:mm:ss") : '-'}</div>)
			},
			{
				Header: "Yüklenen Miktar",
				accessor:"loaded",
				sortable:false,
				Cell: row => (<div>{row.loaded || "-"}</div>)
			},{
				Header: "Harcanan Miktar",
				accessor:"spent",
				sortable:false,
				Cell: row => (<div>{row.spent || "-"}</div>)
			},
			{
				Header: "Kalan Miktar",
				accessor:"spent",
				sortable:false,
				Cell: row => (<div>{((row.loaded || 0) - (row.spent || 0))}</div>)
			},
			{
				Header: "Müşteri Durumu",
				accessor:"customer_isActive",
				sortable:false,
				Cell: row => (<div>{row.customer ? (row.customer.isActive === true ? "Aktif" : "Pasif") : ""}</div>)
			},
			{
				accessor: "finishDate",
				Header: "Sözleşme Bitiş Tarihi",
				sortable:false,
				Cell: row => (
					<div>{moment(row.finishDate).isValid() ? moment(row.finishDate).format("DD-MM-YYYY") : '-'}</div>
				)
			}
		];

		const fields = [
			{
				label: "Müşteri Adı",
				accessor: "customer_customerName",
				type: "text",
				operator: "=",
			},
			{
				label: "VKN/TCKN",
				accessor: "vknTckn",
				type: "numericText",
				operator: "=",
			},
			{
				label: "Birim Türü",
				accessor: "unit",
				type: "select",
				operator: "=",
				selectData: [
					{value: null, label: 'Tümü'},
					{value: '1', label: 'Kontör Adeti'},
					{value: '2', label: defterUnitName(EntegratorConf.identifier)}
				]
			},
			{
				label: "Müşteri Durumu",
				accessor: "customer_isActive",
				type: "select",
				operator: "=",
				selectData: [
					{value: null, label: 'Tümü'},
					{value: true, label: 'Aktif'},
					{value: 'false', label: 'Pasif'}
				]
			}
		];

		return (
			<div className="row  baseBackground">

				<NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth} name="creditList">
					{!((EntegratorIdentifiers.KOLAYSOFT === EntegratorConf.identifier ||
						EntegratorIdentifiers.SMART === EntegratorConf.identifier ||
						EntegratorIdentifiers.MBT === EntegratorConf.identifier) && (this.props.impersonateUserRoleId === 3 || this.props.impersonateUserRoleId === 4)) && <ExcelExporter position="leftSide" url='/credit/exportXls' sheetName='Kredi_Raporu' icon='excel'
								   title="Excel'e Aktar" onClick={() => this.exportXls()}
								   defaultHeaders={defaultHeaders} type='creditReport' completeFetch={true}
									impersonateUserRoleId={this.props.impersonateUserRoleId}/>}

					{!((EntegratorIdentifiers.KOLAYSOFT === EntegratorConf.identifier ||
							EntegratorIdentifiers.SMART === EntegratorConf.identifier ||
							EntegratorIdentifiers.MBT === EntegratorConf.identifier) && (this.props.impersonateUserRoleId === 3 || this.props.impersonateUserRoleId === 4)) &&
						<SquareButton position="leftSide"
									  title="Kredi Hareketlerini Excel'e Aktar"
									  onClick={() => this.setState({modal: true})}
									  img="excel-custom-transfer.png"
									  style={(this.props && this.props.currentUser && (this.props.currentUser.entegrator || (this.props.currentUser.distributor && EntegratorIdentifiers.UNIVERA === EntegratorConf.identifier))) ? {} : {display: "none"}}
									  btnDisabled={false}/>}
				</NavBarKS>

				<div className="col-sm-12 satirBasi">
					<div className="card-header">
						<h4 className="card-title">Kredi Raporu</h4>
					</div>
					<div className="card-body">
						<DetailedSearch fields={fields}
										loading={this.state.searching}
										onSearch={this.handleSearch}/>
					</div>
					<div className="card-body row">
						<Table columns={columns}
							   loading={this.state.loading}
							   loadingText="Kayıtlar getiriliyor..."
							   content={this.state.content}
							   total={this.state.total}
							   page={this.state.page}
							   manual={this.state.manual}
							   size={this.state.size}
							   options={["5", "10", "20", "50", "100"]}
							   fetchData={this.fetchData}
						/>
					</div>
				</div>
                {this.state.modal &&
                    <CreditMovementModal
                        modal={this.state.modal}
                        title="Kredi Hareketlerini Excel'e Aktarma"
                        toggleModal={(flag) => this.setState({modal: flag})}/>
                }
			</div>
		);
	}
}

export default CreditList;